import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const QuickActions = () => {
  const navigate = useNavigate();

  const actions = [
    {
      label: 'User Management',
      description: 'Manage users and permissions',
      icon: 'Users',
      variant: 'default',
      path: '/user-management'
    },
    {
      label: 'Support Tickets',
      description: 'View and respond to tickets',
      icon: 'HelpCircle',
      variant: 'outline',
      path: '/support-tickets'
    },
    {
      label: 'System Maintenance',
      description: 'Server and system controls',
      icon: 'Settings',
      variant: 'outline',
      path: '/system-maintenance'
    },
    {
      label: 'Export Reports',
      description: 'Generate business reports',
      icon: 'Download',
      variant: 'secondary',
      action: 'export'
    }
  ];

  const handleAction = (action) => {
    if (action?.path) {
      navigate(action?.path);
    } else if (action?.action === 'export') {
      // Handle export functionality
      console.log('Exporting reports...');
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">Quick Actions</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {actions?.map((action, index) => (
          <div key={index} className="p-4 border border-border rounded-lg hover:bg-muted/50 transition-micro">
            <div className="space-y-3">
              <div>
                <h4 className="text-sm font-medium text-foreground">{action?.label}</h4>
                <p className="text-xs text-muted-foreground mt-1">{action?.description}</p>
              </div>
              
              <Button
                variant={action?.variant}
                size="sm"
                iconName={action?.icon}
                iconPosition="left"
                onClick={() => handleAction(action)}
                fullWidth
              >
                {action?.label}
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;